//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - Start

import { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BzChip, BzMasterAgGrid } from '../../components';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BEST5_INDEX, MANAGE_COLUMNS_VIEW_TYPES, MULTIPLIER, ORDER_ENTRY_BUTTON_TOGGLE, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useWFHMessages } from '../../hooks';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { FUTURE_GRID_REF, convertColumnsDatatoGridColumns, convertScripResponseWatchlistGrid, convertTOVariable, deepClone, displayZeroStateForGrid, getDynamicParamsForToFixed, isGuestUser, openOrderEntryModal, openOverviewModal, setFutureTabGridRef } from '../../utils/global_functions';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { WatchlistGridPopover } from '../Watchlist';
import { toastConfig } from '../../redux/actions/toast';
import ZeroStates from '../ZeroStates';
import GridHeaderSearch from '../GridHeaderSearch';
import { handleModal } from '../../redux/actions/modals';
import DontMissChip from '../DontMiss/DontMissChip';
let nBaseScripLTP = 0;


const Future = ({ arrFutureTabData, expandScripOverviewModel }) => {
    const dispatch = useDispatch();
    let strSearch = null;
    setFutureTabGridRef(useRef());
    //Vaibhav Singh: BT-116978 : filter option object
    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);

    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    // hari k: need to change watchlistTenantColumnProfiles to get user define colums profile
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - reference error so added deepClone --Start

    const futuresTenantColumnProfiles = useMemo(() => {
        const futuresColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (futuresColumDetails) {
            const updatedColumnDetails = deepClone(futuresColumDetails?.columnDetails)?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails, MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE]?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns, MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        FUTURE_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(FUTURE_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);
    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                //Vaibhav Singh: BT-116978 : Fixed filter for row data in search
                //Azeem k :optamize search functionality 26-10-2023
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.sSymbol + node?.data?.sExchange + node?.data?.expiry;
                let bIsMatch = keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                setTimeout(() => {
                    const arrFiltered = FUTURE_GRID_REF?.current?.api?.getModel()?.rowsToDisplay?.filter((row) => {
                        return row['displayed'] === true;
                    });
                    if (arrFiltered?.length > 0) {
                        dispatch(toastConfig({}));
                    } else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: "No matches found try adjust your search or filter to find what you are looking for" }));
                    }
                }, 10);
                return bIsMatch;
            }
        },
        [strSearch, dispatch]
    );



    const FutureScripDetails = (props) => {
        return (
            <div className='d-flex align-items-center'>
                <div className='font-medium font-size4 color-text text-uppercase me-2'>{props?.arrRowData?.sSymbol}</div>
                <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{props?.arrRowData?.sExchange}</BzChip>
                </div>
                <div className='font-regular font-size4 color-subtext'>{props?.arrRowData.expiry}</div>
            </div>
        );

    };

    const modalData = useSelector(state => state?.modals?.modalData);

    useEffect(() => {
        let arrUnFutUnsubscriptionScrips = [];
        const arrFutureTabDataForSubscription = arrFutureTabData?.map((item) => {
            arrUnFutUnsubscriptionScrips?.push({ exchangeId: item?.MktSegId, token: item?.nToken, isSubscribe: false }); //Ameersha N at a time forming data for unsubscription to avoid space complexity on unmounting this shoudl be done for all componenets to avoid map or forming array while unmounting components
            return { exchangeId: item?.MktSegId, token: item?.nToken, isSubscribe: true };
        });
        arrFutureTabDataForSubscription?.push({ exchangeId: arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetMktId, token: arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetToken, isSubscribe: true, });
        if (arrFutureTabData?.length > 0) {
            arrUnFutUnsubscriptionScrips?.push({ exchangeId: arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetMktId, token: arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetToken, isSubscribe: false, });//Ameersha N at a time forming data for unsubscription to avoid space complexity on unmounting this shoudl be done for all componenets to avoid map or forming array while unmounting components
        }
        sendTouchlineRequest(arrFutureTabDataForSubscription);
        return () => { // Ameersha N -- This unsubscripes futures scrips on unmounting of this componenet
            if (arrUnFutUnsubscriptionScrips?.length > 0) {
                sendTouchlineRequest(arrUnFutUnsubscriptionScrips);
            } else { }
        };

    }, [arrFutureTabData]);
    const bIsPremiumDiscountHide = useMemo(() => scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]?.includes("MCX"), [scripOverviewData]);
    const getFutureGridRowID = useCallback((params) => {
        return params.data['nToken'];
    }, []);

    const handleFutureGrid = (arrTouchLineData) => {
        const nIndex = arrFutureTabData?.findIndex(scrip => scrip.nToken === arrTouchLineData[TL_INDEX.TOKEN]);
        if (nIndex >= 0) {
            let matchedFutureData = arrFutureTabData[nIndex];
            //Vaibhav Singh: BT-116978 : Fixed Decimal Locatore and tofixed and ltp filter
            let wfhObj = {
                ...matchedFutureData,
                id: matchedFutureData?.MktSegId + '_' + matchedFutureData?.nToken,
                nToken: matchedFutureData?.nToken,
                MktSegId: matchedFutureData?.MktSegId,
                expiry: matchedFutureData?.expiry,
                nMarketSegmentId: matchedFutureData?.nMarketSegmentId,
                mktSegId: matchedFutureData?.MktSegId + '_' + matchedFutureData?.nToken,
                sSymbol: matchedFutureData?.sSymbol,
                sSeries: matchedFutureData?.sSeries,
                sInstrumentName: matchedFutureData?.sInstrumentName,
                sSector: matchedFutureData?.sSector,
                ExchangeSegment: matchedFutureData?.ExchangeSegment,
                sSurvMeasureDescription: matchedFutureData?.sSurvMeasureDescription,
                nStrikePrice1: matchedFutureData?.nStrikePrice1,
                sOptionType: matchedFutureData?.sOptionType,
                nSpread: matchedFutureData?.nSpread,
                nRegularLot: matchedFutureData?.nRegularLot,
                sExchange: matchedFutureData?.sExchange,
                nExpiryDate1: matchedFutureData?.nExpiryDate1,
                ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
                changeInPersent: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                changeInPrice: arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],//Azeem K :20-12-2023: remove two plus(+) signs
                dontMiss: matchedFutureData?.dontMiss,
                bidPrice: arrTouchLineData[TL_INDEX.BUY_PRICE],
                bidQty: arrTouchLineData[TL_INDEX.BUY_QTY],
                askPrice: arrTouchLineData[TL_INDEX.SELL_PRICE],
                askQty: arrTouchLineData[TL_INDEX.SELL_QTY],
                premiumDiscount: (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) - nBaseScripLTP).toFixed(getDynamicParamsForToFixed(matchedFutureData?.sExchange)),
                high: arrTouchLineData[TL_INDEX.HIGH_PRICE],
                low: arrTouchLineData[TL_INDEX.LOW_PRICE],
                changeIndicator: arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR],
                DecimalLocator: matchedFutureData?.DecimalLocator,
                bidPriceIndicator: arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR],
                askPriceIndicator: arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR],
                averageTradingPrice: arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE],
                valume: arrTouchLineData[TL_INDEX.VOLUME],
                open: arrTouchLineData[TL_INDEX.OPEN_PRICE],
                close: arrTouchLineData[TL_INDEX.CLOSE_PRICE],
                totalBuyQuantity: arrTouchLineData[TL_INDEX.TOTAL_BUY_QTY],
                totalSellQuentity: arrTouchLineData[TL_INDEX.TOTAL_SELL_QTY],
                openintrest: arrTouchLineData[TL_INDEX.OPEN_INTEREST],
                openintrestPercent: arrTouchLineData[TL_INDEX.OPEN_INTEREST_PERCENT],
                lastUpdatedTime: arrTouchLineData[TL_INDEX.LAST_UPDATED_TIME],
                lastTradeQuentity: arrTouchLineData[TL_INDEX.LAST_TRADE_QTY],
                tradeExecutionRange: arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE] === "" ? `0.${matchedFutureData.decimalLocatorLength > 2 ? "0000" : "00"} - 0.${matchedFutureData.decimalLocatorLength > 2 ? "0000" : "00"}` : arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE],
                spotRate: nBaseScripLTP,
                dpr: arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE],
                fiftyTwoHigh: arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH],
                fiftyTwoLow: arrTouchLineData[TL_INDEX.LIFE_TIME_LOW],
                value: (arrTouchLineData[TL_INDEX.VOLUME] * arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE]),
                code: arrTouchLineData[TL_INDEX.TOKEN],
                marketCapitalization: parseFloat((matchedFutureData.nIssuedCapital * arrTouchLineData[TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES),

            };
            FUTURE_GRID_REF?.current?.api?.applyTransaction({
                update: [wfhObj]

            });

        } else { }
    };

    const futureTabWithBestFive = (bestFiveData) => {
        const nIndex = arrFutureTabData?.findIndex(scrip => scrip.nToken === bestFiveData[BEST5_INDEX.TOKEN]);
        if (nIndex >= 0) {
            let matchedFutureData = arrFutureTabData[nIndex];
            //Vaibhav Singh: BT-116978 : Fixed Decimal Locatore and tofixed and ltp filter
            let wfhObj = {
                ...matchedFutureData,
                id: matchedFutureData?.MktSegId + '_' + matchedFutureData?.nToken,
                nToken: matchedFutureData?.nToken,
                mktSegId: matchedFutureData?.MktSegId + '_' + matchedFutureData?.nToken,
                sSymbol: matchedFutureData?.sSymbol,
                sExchange: matchedFutureData?.sExchange,
                nExpiryDate1: matchedFutureData?.nExpiryDate1,
                expiry: matchedFutureData?.expiry,
                ltp: bestFiveData[BEST5_INDEX.LAST_TRADE_PRICE],
                changeInPersent: bestFiveData[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                changeInPrice: bestFiveData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],//Azeem K :20-12-2023: remove two plus(+) signs
                dontMiss: matchedFutureData?.dontMiss,
                bidPrice: bestFiveData[BEST5_INDEX.BUY_PRICE_1],
                bidQty: bestFiveData[BEST5_INDEX.BUY_QTY_1],
                askPrice: bestFiveData[BEST5_INDEX.SELL_PRICE_1],
                askQty: bestFiveData[BEST5_INDEX.SELL_QTY_1],
                premiumDiscount: (parseFloat(bestFiveData[BEST5_INDEX.LAST_TRADE_PRICE]) - nBaseScripLTP).toFixed(getDynamicParamsForToFixed(matchedFutureData?.sExchange)),
                high: bestFiveData[BEST5_INDEX.HIGH_PRICE],
                low: bestFiveData[BEST5_INDEX.LOW_PRICE],
                changeIndicator: bestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR],
                DecimalLocator: matchedFutureData?.DecimalLocator,
                bidPriceIndicator: bestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR],
                askPriceIndicator: bestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR],
                nAssetToken: matchedFutureData?.nAssetToken,
                open: bestFiveData[BEST5_INDEX.OPEN_PRICE],
                close: bestFiveData[BEST5_INDEX.CLOSE_PRICE],
                totalBuyQuantity: bestFiveData[BEST5_INDEX.TOTAL_BUY_QTY],
                totalSellQuentity: bestFiveData[BEST5_INDEX.TOTAL_SELL_QTY],
                openintrest: bestFiveData[BEST5_INDEX.OPEN_INTEREST],
                openintrestPercent: bestFiveData[BEST5_INDEX.OPEN_INTEREST_PERCENT],
                lastUpdatedTime: bestFiveData[BEST5_INDEX.LAST_UPDATED_TIME],
                lastTradeQuentity: bestFiveData[BEST5_INDEX.LAST_TRADE_QTY],
                tradeExecutionRange: `0.${matchedFutureData.decimalLocatorLength > 2 ? "0000" : "00"} - 0.${matchedFutureData.decimalLocatorLength > 2 ? "0000" : "00"}`,
                spotRate: nBaseScripLTP,
                dpr: bestFiveData[BEST5_INDEX.DAILY_PRICE_RANGE],
                fiftyTwoHigh: bestFiveData[BEST5_INDEX.LIFE_TIME_HIGH],
                fiftyTwoLow: bestFiveData[BEST5_INDEX.LIFE_TIME_LOW],
                value: bestFiveData[BEST5_INDEX.VALUE],
                code: bestFiveData[BEST5_INDEX.TOKEN],
                valume: bestFiveData[BEST5_INDEX.VOLUME],
                averageTradingPrice: bestFiveData[BEST5_INDEX.AVG_TRADED_PRICE],
                marketCapitalization: parseFloat((matchedFutureData.nIssuedCapital * bestFiveData[BEST5_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES),

            };
            FUTURE_GRID_REF?.current?.api?.applyTransaction({
                update: [wfhObj]
            });
        }
    };


    useEffect(() => {
        setTimeout(() => {


            if (arrFutureTabData?.length > 0) {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                const arrBaseScripData = objLastTickData[arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetMktId + '_' + arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetToken];
                if (arrBaseScripData?.length > 0) {
                    nBaseScripLTP = parseFloat(arrBaseScripData[TL_INDEX.LAST_TRADE_PRICE]);
                }
                arrFutureTabData?.forEach((scrip) => {
                    const key = scrip.MktSegId + '_' + scrip.nToken;
                    const arrLastTickData = objLastTickData[key];
                    if (arrLastTickData?.length > 0) {
                        handleFutureGrid(arrLastTickData);
                    } else {
                        //Vaibhav Singh: BT-116978 : Fixed showing zero in case of no data present
                        let wfhObj = {
                            ...scrip,
                            id: scrip?.MktSegId + '_' + scrip?.nToken,
                            nToken: scrip?.nToken,
                            mktSegId: scrip?.MktSegId + '_' + scrip?.nToken,
                            sSymbol: scrip?.sSymbol,
                            sExchange: scrip?.sExchange,
                            nExpiryDate1: scrip?.nExpiryDate1,
                            expiry: scrip?.expiry,
                            ltp: (0).toFixed(scrip?.decimalLocatorLength),
                            changeInPersent: (0).toFixed(2),
                            changeInPrice: (0).toFixed(scrip?.decimalLocatorLength),
                            dontMiss: scrip?.dontMiss,
                            bidPrice: (0).toFixed(scrip?.decimalLocatorLength),
                            bidQty: 0,
                            askPrice: (0).toFixed(scrip?.decimalLocatorLength),
                            askQty: 0,
                            premiumDiscount: (0).toFixed(scrip?.decimalLocatorLength),
                            high: (0).toFixed(scrip?.decimalLocatorLength),
                            low: (0).toFixed(scrip?.decimalLocatorLength),
                            changeIndicator: (0).toFixed(scrip?.decimalLocatorLength),
                            DecimalLocator: scrip?.DecimalLocator,
                            bidPriceIndicator: (0).toFixed(scrip?.decimalLocatorLength),
                            askPriceIndicator: (0).toFixed(scrip?.decimalLocatorLength),
                            nAssetToken: scrip?.nAssetToken,
                            dpr: (0).toFixed(2),
                            valume: 0,
                            averageTradingPrice: (0).toFixed(2),
                            open: (0).toFixed(2),
                            close: (0).toFixed(2),
                            value: 0,
                            totalBuyQuantity: 0,
                            totalSellQuentity: 0,
                            openintrest: 0,
                            openintrestPercent: (0).toFixed(2),
                            lastTradeQuentity: 0,
                            fiftyTwoHigh: (0).toFixed(2),
                            fiftyTwoLow: (0).toFixed(2),
                            spotRate: (0).toFixed(2),
                            lastUpdatedTime: (0).toFixed(2),
                            marketCapitalization: (0).toFixed(2),
                            tradeExecutionRange: '0.00-0.00',
                            code: (0).toFixed(2),
                        };
                        FUTURE_GRID_REF?.current?.api?.applyTransaction({
                            update: [wfhObj]
                        });
                    }

                });


            }
        }, 100);
    }, [arrFutureTabData]);

    useWFHMessages('touchline', (e) => {
        const arrTL = [...e.detail];
        handleFutureGrid(arrTL);
        if (arrTL[TL_INDEX.SEGMENT_ID] === arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetMktId && arrTL[TL_INDEX.TOKEN] === arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetToken) {
            nBaseScripLTP = parseFloat(arrTL[TL_INDEX.LAST_TRADE_PRICE]);

        } else { }


    });
    useWFHMessages('bestfive', (e) => {
        const arrBestFive = [...e.detail];
        if (arrBestFive[BEST5_INDEX.SEGMENT_ID] === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] && arrBestFive[BEST5_INDEX.TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]) {
            futureTabWithBestFive(arrBestFive);
        }
        if (arrBestFive[BEST5_INDEX.SEGMENT_ID] === arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetMktId && arrBestFive[BEST5_INDEX.TOKEN] === arrFutureTabData[arrFutureTabData?.length - 1]?.nAssetToken) {
            nBaseScripLTP = Number(arrBestFive[BEST5_INDEX.LAST_TRADE_PRICE]);
        }
    });

    //Vaibhav Singh: BT-116978 : 05-09-2023 : Fixed issue with Filter of text and number
    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = FUTURE_GRID_REF?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };

    const FutureRowData = ({ value }) => { return value; };


    const arrFuturesGridColDefs = useMemo(() => {
        if (futuresTenantColumnProfiles?.length) {
            const arrPositionColumnDefs = futuresTenantColumnProfiles?.map((item) => {
                switch (item.field) {
                    case "nToken": {
                        item = {
                            ...item, hide: true
                        };
                        return item;
                    } case "mktSegId": {
                        item = {
                            ...item, hide: true
                        };
                        return item;
                    }
                    case "sSymbol": {
                        item = {
                            ...item, pinned: 'left',
                            suppressMovable: true,
                            lockPosition: "left",
                            suppressNavigable: true, cellRenderer: ({ data: arrRowData, ...props }) => (
                                <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                                    <FutureScripDetails arrRowData={arrRowData} />
                                </WatchlistGridPopover>
                            ),
                            headerComponent: GridHeaderSearch,
                            headerComponentParams: { onChangeGridHeaderSearch, gridRef: FUTURE_GRID_REF },
                            minWidth: 250, valueGetter: (params) => {
                                const myColumn = params.data;
                                const expiry = `${new Date(myColumn.nExpiryDate1).getDate()} ${new Date(myColumn.nExpiryDate1).toLocaleString('default', { month: 'short' })} '${new Date(myColumn.nExpiryDate1).getFullYear() % 100}`;
                                return `${myColumn.sSymbol}${myColumn.sExchange} ${expiry}`;
                            },

                        };
                        return item;
                    }
                    case "ltp": {
                        item = {
                            ...item,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                            cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                                'background-positive color-active-text': params => params?.data?.changeIndicator === 'U',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'background-negative color-active-text': params => params?.data?.changeIndicator === 'D',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                '': params => params?.data?.changeIndicator === 'S',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            }
                        };
                        return item;
                    }
                    case "changeInPersent": {
                        item = {
                            //Vaibhav Singh: BT-116978 : Fixed changes % filter equals
                            ...item, filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry}{...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                            cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'color-positive': params => params?.data?.changeInPersent?.split("")[0] === '+',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'color-negative': params => params?.data?.changeInPersent?.split("")[0] === '-',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences- End
                            }
                        };
                        return item;
                    }
                    case "bidPrice": {
                        item = {
                            ...item, filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                            cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'background-positive color-active-text': params => params?.data?.bidPriceIndicator === 'U',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'background-negative color-active-text': params => params?.data?.bidPriceIndicator === 'D',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                '': params => params?.data?.bidPriceIndicator === 'S',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            }
                        };
                        return item;
                    }
                    case "askPrice": {
                        item = {
                            ...item,  filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry}  {...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                            cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'background-positive color-active-text': params => params?.data?.askPriceIndicator === 'U',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'background-negative color-active-text': params => params?.data?.askPriceIndicator === 'D',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                '': params => params?.data?.askPriceIndicator === 'S',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            }
                        };
                        return item;
                    }
                    case "askQty": {
                        item = {
                            ...item, filter: 'agNumberColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry}  {...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case "premiumDiscount": {
                        item = {
                            ...item,  filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry}  {...props}>
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                            hide: bIsPremiumDiscountHide,
                            //  cellClassRules: {
                            //     //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                            //     'background-positive color-active-text': params => params?.data?.premiumDiscount > 0,   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            //     'background-negative color-active-text': params => params?.data?.premiumDiscount < 0,   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            //     //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            // }
                        };
                        return item;
                    }

                    case "high": {
                        item = {
                            ...item,  filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => {
                                return <WatchlistGridPopover placement='left' arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                                    <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                                </WatchlistGridPopover>;
                            }, filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                        };
                        return item;
                    }
                    case "low": {
                        item = {
                            ...item,  filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover placement='left' arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props} >
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>, filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                        };
                        return item;
                    }
                    case "dontMiss": {
                        item = {
                            ...item,  filter: 'agTextColumnFilter',
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                                {/* <FutureRowData value={value} arrRowData={arrRowData} {...props} /> */}
                                <div className='scrip-wrap text-center'>
                                    <div className='chips-wrap d-flex justify-content-center align-items-center'><DontMissChip nShowChip={1} value={value ? value : []} /></div></div>
                            </WatchlistGridPopover>
                            // cellRenderer: (props) => <div className='chips-wrap'><DontMissChip nShowChip={1} value={props?.data?.dontMiss} /></div>,
                            // valueGetter: (params) => params?.data?.dontMiss
                        };
                        return item;
                    }
                    default:
                        return {
                            ...item,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover placement='left' arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props} >
                                <FutureRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>, filterParams: {
                                textMatcher: getFilterDataForGrid,
                                filterOptions: filterOptions
                            },
                        };

                }
            });
            let isSymbolPresent = futuresTenantColumnProfiles?.find(elem => elem?.headerName === 'SYMBOL');
            if (!isSymbolPresent) {
                let item = {
                    headerName: 'SYMBOL',
                    field: 'sSymbol',
                    pinned: 'left',
                    suppressMovable: true,
                    lockPosition: "left",
                    suppressNavigable: true, cellRenderer: ({ data: arrRowData, ...props }) => (
                        <WatchlistGridPopover arrRowData={convertScripResponseWatchlistGrid([arrRowData])[0]} isAddtoWatchlist isExpiry={true} strFutureExpiry={props?.node.data.expiry} {...props}>
                            <FutureScripDetails arrRowData={arrRowData} />
                        </WatchlistGridPopover>
                    ),
                    headerComponent: GridHeaderSearch,
                    headerComponentParams: { onChangeGridHeaderSearch, gridRef: FUTURE_GRID_REF },
                    minWidth: 250, valueGetter: (params) => {
                        const myColumn = params.data;
                        const expiry = `${new Date(myColumn.nExpiryDate1).getDate()} ${new Date(myColumn.nExpiryDate1).toLocaleString('default', { month: 'short' })} '${new Date(myColumn.nExpiryDate1).getFullYear() % 100}`;
                        return `${myColumn.sSymbol}${myColumn.sExchange} ${expiry}`;
                    },

                };
                arrPositionColumnDefs.unshift(item);
            }
            const nIndex = futuresTenantColumnProfiles?.findIndex(elem => elem?.headerName === '');
            if (nIndex >= 0) {
                arrPositionColumnDefs[nIndex] = {
                    colId: "check",
                    hide: true,
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                    showDisabledCheckboxes: true,
                    pinned: 'left',
                    width: '40'
                };
            } else { }
            return arrPositionColumnDefs;
        } else {
            return [];
        }
    }, [futuresTenantColumnProfiles, userColumnProfiles]);
    const objLoginSession = useSelector(state => state.auth?.objLoginSession);


    // useSingleKey('f1', (e) => {
    //     // For Buy Order Entry ShortCut
    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     if (!isGuestUser()) {
    //         if (FUTURE_GRID_REF?.current?.api.getSelectedRows().length > 0) {
    //             const arrSelectedRowScripData = convertScripResponseWatchlistGrid([FUTURE_GRID_REF?.current?.api?.getSelectedRows()[0]])[0];
    //             if (arrSelectedRowScripData?.length > 0) {
    //                 openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    //                 dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

    //             } else { }
    //         } else { }
    //     }
    //     else {
    //         dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
    //     }
    // });

    // useSingleKey('f2', (e) => {
    //     // For Sell Order Entry ShortCut
    //     e.preventDefault(); // Prevent the default browser behavior for F2 key press
    //     if (!isGuestUser()) {
    //         if (FUTURE_GRID_REF?.current?.api.getSelectedRows().length > 0) {
    //             const arrSelectedRowScripData = convertScripResponseWatchlistGrid([FUTURE_GRID_REF?.current?.api?.getSelectedRows()[0]])[0];
    //             if (arrSelectedRowScripData?.length > 0) {
    //                 openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    //                 dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

    //             } else { }
    //         } else { }
    //     }
    //     else {
    //         dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
    //     }
    // });

    const handleOverview = () => {
        if (!isGuestUser()) {
            if (FUTURE_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                const arrSelectedRowScripData = convertScripResponseWatchlistGrid([FUTURE_GRID_REF?.current?.api?.getSelectedRows()[0]])[0];
                if (arrSelectedRowScripData?.length > 0) {
                    openOverviewModal(false, arrSelectedRowScripData, false, false, dispatch, modalData);
                }
            }
            else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }
    };


    // useSingleKey('f5', (e) => {
    //     handleOverview(e);
    //     e.preventDefault(); // Prevent the default browser behavior for F5 key press
    // });
    // useSingleKey('enter', (e) => {
    //     handleOverview(e);
    //     e.preventDefault(); // Prevent the default browser behavior for F5 key press
    // });

    const onRowSelected = (e) => {
        FUTURE_GRID_REF?.current?.api?.forEachNode((node) => {
            if (node.id === e?.node?.id) {
                node.setSelected(true);
            } else {
                node.setSelected(false);
            }

        });

    };

    const handleKeyEvents = useCallback((e) => {
        let key = e?.key?.toLowerCase();
        switch (key) {
            case 'f1':
                // For Buy Order Entry ShortCut
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                if (!isGuestUser()) {
                    if (FUTURE_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                        const arrSelectedRowScripData = convertScripResponseWatchlistGrid([FUTURE_GRID_REF?.current?.api?.getSelectedRows()[0]])[0];
                        if (arrSelectedRowScripData?.length > 0) {
                            openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

                        } else { }
                    } else { }
                }
                else {
                    dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
                }
                break;
            case 'f2':
                e.preventDefault(); // Prevent the default browser behavior for F2 key press
                if (!isGuestUser()) {
                    if (FUTURE_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                        const arrSelectedRowScripData = convertScripResponseWatchlistGrid([FUTURE_GRID_REF?.current?.api?.getSelectedRows()[0]])[0];
                        if (arrSelectedRowScripData?.length > 0) {
                            openOrderEntryModal(arrSelectedRowScripData, arrSelectedRowScripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

                        } else { }
                    } else { }
                }
                else {
                    dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
                }
                break;
            case 'f5':
                handleOverview(e);
                e.preventDefault();
                break;
            case 'enter':
                handleOverview(e);
                e.preventDefault();
                break;
            default: break;
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents);
        return () => {
            document.removeEventListener('keydown', handleKeyEvents);
        };
    }, [handleKeyEvents]);

    return (
        <Container fluid className='p-0'>
            {arrFutureTabData?.length > 0 ?
                <BzMasterAgGrid
                    gridProfileType={MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE}
                    onRowClicked={onRowSelected}
                    rowSelection='single'
                    arrRowData={arrFutureTabData}
                    arrColumnData={arrFuturesGridColDefs}
                    className={`ag-theme-alpine d-flex-1 ${expandScripOverviewModel ? "future-ag-grid-wrapper-expand" : "future-ag-grid-wrapper"}`}
                    ref={FUTURE_GRID_REF}
                    getRowId={getFutureGridRowID}
                    isExternalFilterPresent={isExternalFilterPresent}
                    doesExternalFilterPass={doesExternalFilterPass}
                />
                :
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <ZeroStates subText="No Data Found" />
                </div>
            }
        </Container>

    );
};

export default memo(Future);

//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End